// extracted by mini-css-extract-plugin
export default {"header":"RightSide_header__eRUQn","sort":"RightSide_sort__WxnhI"};